// Components
import Vue from 'vue'

import XLSX from 'xlsx'
let localApp = new Vue({})

let exportHelper = {
  ToExcel: function (fields, data, exportTitle) {
    // Ajuste de coluna / header para ficar com o nome correto.
    const columnInfo = fields.reduce(
      (acc, column) => {
        const headerLabel = (column.label || column.key) || column.field
        acc.header.push(headerLabel)
        acc.map[column.key || column.field] = headerLabel
        return acc
      },
      { map: {}, header: [] }
    )

    // Translate the keys of each row object to the new header label
    // Turning `{a: 1, b: 2, c: 3}` into `{"Nice name for a": 1, "Nice name for b": 2}`.
    const mappedData = data.map((row) =>
      Object.entries(row).reduce((acc, [key, value]) => {
        if (columnInfo.map[key]) {
          acc[columnInfo.map[key]] = value
        }
        return acc
      }, {})
    )

    var xlsData = XLSX.utils.json_to_sheet(mappedData, {})

    /* change cell format if numeric */
    let countCollumns = fields.length
    let countLines = data.length
    var fmt = '0.00'
    var range = { s: { c: 0, r: 0 }, e: { c: countCollumns, r: countLines } }
    for (var R = range.s.r; R <= range.e.r; ++R) {
      for (var C = range.s.c; C <= range.e.c; ++C) {
        var cell = xlsData[XLSX.utils.encode_cell({ r: R, c: C })]
        if (cell && localApp.$api.UI.IsDecimalString(cell.v)) {
          cell.v = localApp.$api.UI.GetDecimalOrNull(cell.v)
          cell.t = 'n'
          cell.z = fmt
        }
      }
    }
    var wb = XLSX.utils.book_new() // make Workbook of Excel

    XLSX.utils.book_append_sheet(wb, xlsData, 'Planilha 1')
    XLSX.writeFile(wb, exportTitle + '.xlsx')
  }
}

export default exportHelper



// WEBPACK FOOTER //
// ./src/_api/exportHelper.js